export default __webpack_public_path__ + "static/bt_design-9fccd46448a676cda7ea36e8e42cef87.png";